import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { HomeComponent } from './home.component';
import { pageGuardInjectable } from 'src/app/services/helpers/page-guard-injectable';
import { TestModule } from '../test/test.module';
import { SettingsModule } from '../settings/settings.module';
import { UserInfoComponent } from '../user/user-info/user-info.component';
import { ClientiComponent } from '../clienti/clienti.component';
import { ClientiFormComponent } from '../clienti/clienti-form/clienti-form.component';
import { GestionePartiteComponent } from '../gestione-partite/gestione-partite.component';
import { FormPartiteComponent } from '../gestione-partite/form-partite/form-partite.component';
import { GestioneMissioniComponent } from '../gestione-missioni/gestione-missioni.component';
import { FormMissioniComponent } from '../gestione-missioni/form-missioni/form-missioni.component';
import { GestioneEnigmiComponent } from '../gestione-enigmi/gestione-enigmi.component';
import { FormEnigmiComponent } from '../gestione-enigmi/form-enigmi/form-enigmi.component';
import { FormStepComponent } from '../gestione-step/form-step/form-step.component';
import { FormStorieEnigmiComponent } from '../storie-enigmi/form-storie-enigmi/form-storie-enigmi.component';
import { MissioniEsplorativeComponent } from '../missioni-esplorative/missioni-esplorative.component';
import { FormMissioniEsplorativeComponent } from '../missioni-esplorative/form-missioni-esplorative/form-missioni-esplorative.component';
import { PoiComponent } from '../poi/poi.component';
import { FormPoiComponent } from '../poi/form-poi/form-poi.component';




const routes: Routes = [
  {
    path: '', component: HomeComponent, children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        //canActivate: [pageGuardInjectable]
      },
      // {
      //   path: 'masterdata',
      //   loadChildren: () => import('../masterdata/masterdata.module').then(m => m.MasterdataModule),
      //   //canActivate: [pageGuardInjectable],
      //   //canActivateChild: [pageGuardInjectable],
      // },
      {
        path: 'gestione-utenti',
        loadChildren: () => import('../user/user.module').then(m => m.UserModule),
        // canActivate: [pageGuardInjectable],
        // canActivateChild: [pageGuardInjectable],
      },


      { path: 'me', loadComponent: () => UserInfoComponent },


      { path: 'clienti', loadComponent: () => ClientiComponent },
      { path: 'clienti/new', loadComponent: () => ClientiFormComponent },
      { path: 'clienti/:id', loadComponent: () => ClientiFormComponent },


      { path: 'partite', loadComponent: () => GestionePartiteComponent },
      { path: 'partite/new', loadComponent: () => FormPartiteComponent },
      { path: 'partite/:id', loadComponent: () => FormPartiteComponent },


      { path: 'missioni', loadComponent: () => GestioneMissioniComponent },
      { path: 'missioni/new/:id', loadComponent: () => FormMissioniComponent },
      { path: 'missioni/:id', loadComponent: () => FormMissioniComponent },


      { path: 'step/new/:id', loadComponent: () => FormStepComponent },
      { path: 'step/:id', loadComponent: () => FormStepComponent },


      { path: 'enigmi', loadComponent: () => GestioneEnigmiComponent },
      { path: 'enigmi/new/:id', loadComponent: () => FormEnigmiComponent },
      { path: 'enigmi/:id', loadComponent: () => FormEnigmiComponent },


      //{ path: 'storie', loadComponent: () => GestioneEnigmiComponent },
      { path: 'storie/new/:id', loadComponent: () => FormStorieEnigmiComponent },
      { path: 'storie/:id', loadComponent: () => FormStorieEnigmiComponent },

      { path: 'missioni-esplorative', loadComponent: () => MissioniEsplorativeComponent },
      { path: 'missioni-esplorative/new', loadComponent: () => FormMissioniEsplorativeComponent },
      { path: 'missioni-esplorative/new/:adventureId', loadComponent: () => FormMissioniEsplorativeComponent },
      { path: 'missioni-esplorative/:id', loadComponent: () => FormMissioniEsplorativeComponent },

      { path: 'poi', loadComponent: () => PoiComponent },
      { path: 'poi/new', loadComponent: () => FormPoiComponent },
      { path: 'poi/:id', loadComponent: () => FormPoiComponent },


      {
        path: 'test',
        loadChildren: () => TestModule,
        //  canActivate: [pageGuardInjectable]
      },

      {
        path: 'settings',
        loadChildren: () => SettingsModule,
      },
    ]
  },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
